module.exports = __webpack_public_path__ + "media/chip-532cdc30.svg";